<template>
  <div>
    <a target="_blank" :href="recording.shareableUrl" class="text-yellow text-decoration-underline">
      View attached recording
    </a>
  </div>
</template>

<script>

export default {
  props: {
    recording: {
      type: Object,
      required: false,
    },
  },
};
</script>

<style scoped>
.text-decoration-underline {
  text-decoration: underline !important;
}
</style>
